import React, { useState } from 'react'

import DatePicker from 'react-datepicker'
import { useTranslation } from 'react-i18next'

import { AccountingSystemDialog } from '../common/AccountingSystemDialog'
import { datePickerDateFormat } from '../common/i18n'
import axiosClient from '../service/axiosClient'
import { AccountingSystem } from '../types/AccountingSystem'
import { InvoicesFilter } from '../types/Invoice'

interface Props {
    filter: InvoicesFilter
    setFilter: React.Dispatch<React.SetStateAction<InvoicesFilter>>
}

export const InvoicesListFilter = ({filter, setFilter}: Props) => {
    const {t} = useTranslation()
    const [showSystemDialog, setShowSystemDialog] = useState(false)

    function downloadAllInvoices(system: AccountingSystem) {
        axiosClient({
            url: '/invoice-export/download-all',
            method: 'GET',
            responseType: 'blob',
            params: {system},
        }).then((response) => {
            const href = URL.createObjectURL(response.data)
            const link = document.createElement('a')
            link.href = href
            link.setAttribute('download', 'faktury.zip')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
        })
    }

    return (
        <>
            <div className="rounded-content-body mb-4">
                <div className="row d-flex align-items-end">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="entryDate">{t('date_from')}</label>
                            <DatePicker
                                scrollableYearDropdown
                                yearDropdownItemNumber={100}
                                locale="sk"
                                dateFormat={datePickerDateFormat}
                                showYearDropdown
                                selected={(filter.from && new Date(filter.from)) || null}
                                onChange={(value: any) => {
                                    setFilter((old) => ({...old, from: value}))
                                }}
                                id="from"
                                name="from"
                                className="form-control"/>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="entryDate">{t('date_to')}</label>
                            <DatePicker
                                scrollableYearDropdown
                                yearDropdownItemNumber={100}
                                locale="sk"
                                dateFormat={datePickerDateFormat}
                                showYearDropdown
                                selected={(filter.to && new Date(filter.to)) || null}
                                onChange={(value: any) => {
                                    setFilter((old) => ({...old, to: value}))
                                }}
                                id="until"
                                name="until"
                                className="form-control"/>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="form-group">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="unpaidOnly"
                                    checked={filter.unpaidOnly}
                                    onChange={(e) => {
                                        setFilter((old) => ({...old, unpaidOnly: e.target.checked}))
                                    }}
                                />
                                <label className="form-check-label" htmlFor="unpaidOnly">
                                    {t('only_unpaid')}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="form-group">
                            <button
                                type="button"
                                className="btn amani-primary"
                                onClick={() => setShowSystemDialog(true)}
                                title={t('download_all_invoices_zip')}
                            >
                                <i className="bi bi-file-earmark-zip me-2"></i>
                                {t('download_all')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <AccountingSystemDialog show={showSystemDialog}
                                    onClose={() => setShowSystemDialog(false)}
                                    onConfirm={downloadAllInvoices}/>
        </>
    )
}